import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardQueries } from '../../../../cp/shared/enums/DashboardQueries';
import { widgetFilters } from '../../../shared/enums/widgetFilters';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';

@Component({
    selector: 'cp-order-review-lite',
    templateUrl: './order-review-lite.component.html',
    styleUrls: ['./order-review-lite.component.scss']
})
export class OrderReviewLiteComponent implements OnInit {

    constructor() { }

    @Input() chartType: string;
    @Input() inputSearchParams: WidgetSearch;
    @Output() loaderState = new EventEmitter<any>();
    @Output() loaderErrorState = new EventEmitter<any>();
    @Output() searchParams = new EventEmitter<WidgetSearch>(true);

    widgetQuery: DashboardQueries = DashboardQueries.orderReviewLite;
    chartSearchFilters: widgetFilters[] = [widgetFilters.svcMgr,
        widgetFilters.buyer,
        widgetFilters.supplier,
        widgetFilters.orderStatus,
        widgetFilters.divisions,
        widgetFilters.customer,
        widgetFilters.svcConst,
        widgetFilters.isSub,
        widgetFilters.acctMgr,
        widgetFilters.priority,
        widgetFilters.class,
        widgetFilters.requestor,
        widgetFilters.regions,
        widgetFilters.techCreated,
        widgetFilters.onCallRegion];

    ngOnInit() {
    }

    changeLoader(e) {
        this.loaderState.emit(e);
    }

    changeErrorLoader(e) {
        this.loaderErrorState.emit(e);
    }

    setSearchParams(searchParams: WidgetSearch) {
        this.searchParams.emit(searchParams);
    }
}
